const male = {
  "01:00T02:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "03:00T04:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "05:00T06:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "07:00T08:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "09:00T10:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "11:00T12:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "13:00T14:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "15:00T16:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "17:00T18:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "19:00T20:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "21:00T22:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "23:00T00:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
};

const female = {
  "00:00T01:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "02:00T03:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "08:00T09:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "10:00T11:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "14:00T15:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
  "16:00T17:00": { status: true, days: [0, 1, 2, 3, 4, 5, 6] },
};


export { male, female };
